// extracted by mini-css-extract-plugin
module.exports = {"container":"radio_container__ZOIii","label":"radio_label__c8gx_","input":"radio_input__tdnN5","phAnimation":"radio_phAnimation__Zf3Ae"};